import { createStandardAction } from 'typesafe-actions';
import { FeedEventData } from '@tradingblock/types';

export const FEED_CLOSED = `@loginCount/feed/closed`;
export const FEED_ERRORED = `@loginCount/feed/errored`;
export const FEED_CONNECTED = `@loginCount/feed/connected`;
export const feedClosed = createStandardAction(FEED_CLOSED)<FeedEventData>();
export const feedErrored = createStandardAction(FEED_ERRORED)<FeedEventData>();
export const feedConnected = createStandardAction(FEED_CONNECTED)();

export const LoginCountFeedActions = {
  loginCountFeedClosed: createStandardAction(FEED_CLOSED)<FeedEventData>(),
  loginCountFeedErrored: createStandardAction(FEED_ERRORED)<FeedEventData>(),
  loginCountFeedConnected: createStandardAction(FEED_CONNECTED)(),
};
